var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    _vm._b(
      {
        staticClass:
          "block py-1 overflow-hidden relative border border-gray focus-within:border-blue",
      },
      "label",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "div",
        {
          staticClass:
            "mui-textfield mui-textfield--float-label mui-textfield--no-underline mui-textfield--inherit-color mui-textfield--reduced-range mui-textfield--programmatic mui-textfield--label-medium mui-textfield--label-gray pl-4 lg:pl-6 pr-8 lg:pr-10 m-0",
          class: { "mui-textfield--label-gray": _vm.grayLabel },
        },
        [
          _c("input", {
            ref: "input",
            staticClass: "overflow-ellipsis font-[500]",
            class: { "pointer-events-none": _vm.readonly },
            attrs: { name: _vm.name, readonly: _vm.readonly },
            domProps: { value: _vm.value },
            on: { focus: _vm.handleFocus, input: _vm.handleInput },
          }),
          _vm._v(" "),
          _c("label", { domProps: { textContent: _vm._s(_vm.label) } }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "absolute right-4 lg:right-2 2xl:right-4 bottom-[1.125rem] transition-transform duration-300",
          class: { "-scale-y-100": _vm.isOpened, "-translate-y-2": !_vm.value },
        },
        [
          _c("svg", { attrs: { width: "24", height: "24" } }, [
            _c("use", { attrs: { "xlink:href": "#chevron-24x24-down" } }),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }